// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xdh456V25kU3zsRFRvcm{font-weight:bold;font-size:16px}`, "",{"version":3,"sources":["webpack://./src/components/listings/MainTotalItems/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACA,cAAA","sourcesContent":[".totalItemsContainer\n  font-weight: bold\n  font-size: 16px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"totalItemsContainer": `xdh456V25kU3zsRFRvcm`
};
export default ___CSS_LOADER_EXPORT___;
